export default "https://cdn.questicon.mathletics.com/assets/images/Smiling Face with Sunglasses-2da8dd760382e95d5d02422d953af0de.svg";